export const getActiveTabIndex = (pathname: string) => {
  if (pathname === '/data-management') return 0;
  else return 1;
};
